module.exports = __webpack_public_path__ + "img/FUN-Menu-15.8e65f5c8.png";